/* eslint-disable  */

import { api } from '../api';

export const itpApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getITPList: builder.query({
            query: (payload) => ({
                url: '/api/itp/itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['ITPList']
        }),
        getITPV2List: builder.query({
            query: (payload) => ({
                url: '/api/itp/classroom-itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['ITPV2List']
        }),
        getITPDetails: builder.query({
            query: (payload) => ({
                url: '/api/itp/itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DETAIL'
                }
            }),
            providesTags: ['ITPDetails']
        }),

        getITPV2Details: builder.query({
            query: (payload) => ({
                url: '/api/itp/classroom-itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DETAIL'
                }
            }),
            providesTags: ['ITPV2Details']
        }),

        getQTRDetails: builder.query({
            query: (payload) => ({
                url: '/api/itp/qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DETAIL'
                }
            }),
            providesTags: ['QTRDetails']
        }),
        addUpdateITP: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: payload.id ? 'update' : 'create'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPList', 'ITPDetails', 'ADDT_ITPDetails'] : [])
        }),

        addUpdateITPV2: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/classroom-itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: payload.id ? 'update' : 'create'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPV2List'] : [])
        }),

        addParentSign: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/classroom-itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'parent_sign'
                }
            })
            // invalidatesTags: (result, error, arg) => (result ? ['ITPV2List'] : [])
        }),

        addUpdateQTR: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: payload.id ? 'update' : 'create'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPList', 'QTRDetails'] : [])
        }),

        deleteITP: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'delete'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPList'] : [])
        }),
        deleteITPEIDT: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/classroom-itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'delete'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPV2List'] : [])
        }),
        itpSign: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'sign'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPList', 'ITPDetails', 'UnsignedReportsList', 'ADDT_ITPDetails'] : [])
        }),
        qtrSign: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'sign'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPList', 'QTRDetails', 'UnsignedReportsList'] : [])
        }),

        itpEidtSign: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/classroom-itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'sign'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPV2List'] : [])
        }),

        requestSign: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'notify_therpist'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPList', 'ITPDetails', 'ADDT_ITPDetails'] : [])
        }),

        closeITP: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'close_itp'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPList', 'ITPDetails', 'ADDT_ITPDetails'] : [])
        }),

        closeITPEIDT: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/classroom-itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'close_classroom_itp'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPV2List'] : [])
        }),
        closeQTR: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'close_itp'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPList', 'QTRDetails'] : [])
        }),
        unlockITP: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'unlock'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPList', 'ITPDetails', 'ADDT_ITPDetails'] : [])
        }),
        unlockITPEIDT: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/classroom-itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'unlock_classroom_itp'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['ITPV2List', 'ITPV2Details'] : [])
        }),
        getItpHistory: builder.query({
            query: (payload) => ({
                url: '/api/itp/itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'activity'
                }
            })
            // providesTags: ['ITPHistory']
        }),

        getItpEidtHistory: builder.query({
            query: (payload) => ({
                url: '/api/itp/classroom-itp/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'classroom_itp_activity'
                }
            })
            // providesTags: ['ITPHistory']
        }),

        attendanceCheckinCheckout: builder.mutation({
            query: ({ payload, checkin }) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: checkin === 'checkin' ? 'studcheckin' : checkin === 'checkout' ? 'studcheckout' : 'studtcont'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails'] : [])
        }),
        therapyCheckinCheckout: builder.mutation({
            query: ({ payload, checkin }) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: checkin ? 'studthrpyin' : 'studthrpyout'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails'] : [])
        }),

        getTherapyHistory: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'studthrpyhistory'
                }
            })
        }),
        updateTherapyHistory: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'studthrpyhistoryupdate'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails'] : [])
        }),

        getSwitchClassrooms: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['ClassroomList', 'ClassroomActiveList']
        }),

        lockUnlockSession: builder.mutation({
            query: (payload) => ({
                url: 'api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'lock'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails', 'SessionList'] : [])
        }),

        // session goals
        getSessionGoals: builder.query({
            query: (payload) => ({
                url: 'api/classroom/student-goals/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'lstsesngls'
                }
            }),
            providesTags: ['SessionGoals']
        }),
        addStudentGoalsResult: builder.mutation({
            query: (payload) => ({
                url: 'api/classroom/student-goals/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'adstdgolrslt'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionGoals'] : [])
        }),
        getSessionHistory: builder.query({
            query: (payload) => ({
                url: 'api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'activity'
                }
            }),
            invalidatesTags: ['SessionHistory']
        }),
        getPdcSessionServiceAvailed: builder.query({
            query: (payload) => ({
                url: 'api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'serviceavailed'
                }
            })
        }),
        getSessionStudents: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'studlst'
                }
            }),
            providesTags: ['SessionStudentList']
        }),
        changeStudentAttendance: builder.mutation({
            query: ({ payload, present }) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: present ? 'pdcattendance' : 'pdcpickup'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['StudentList', 'SessionStudentList', 'SessionDetails'] : [])
        }),
        startSession: builder.mutation({
            query: (payload) => ({
                url: 'api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'checkincheckout'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionList', 'SessionDetails'] : [])
        }),
        getEarlyDismissalReasons: builder.query({
            query: (payload) => ({
                url: 'api/core/early-dismiss-reason/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
        }),

        // -- ADDT QTR REVIEW
        getAddtQtrDetails: builder.query({
            query: (payload) => ({
                url: '/api/itp/session-qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DETAIL'
                }
            }),
            providesTags: ['AddtQtrDetails']
        }),
        addUpdateAddtQtr: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/session-qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: payload.id ? 'update' : 'create'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['AddtQtrList', 'AddtQtrDetails'] : [])
        }),
        AddtQtrSign: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/session-qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'sign'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['AddtQtrList', 'AddtQtrDetails', 'UnsignedReportsList'] : [])
        }),
        AddtQtrRequestSign: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/session-qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'notify_therpist'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['AddtQtrList', 'AddtQtrDetails'] : [])
        }),
        closeAddtQtr: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/session-qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'close_session_qtr'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['AddtQtrList', 'AddtQtrDetails'] : [])
        }),
        getAddtQtrList: builder.query({
            query: (payload) => ({
                url: '/api/itp/session-qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['AddtQtrList']
        }),
        getAddtQtrHistory: builder.query({
            query: (payload) => ({
                url: '/api/itp/session-qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'activity'
                }
            })
            // providesTags: ['ITPHistory']
        }),
        unlockAddtQtr: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/session-qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'unlock'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['AddtQtrList', 'AddtQtrDetails'] : [])
        }),
        deleteAddtQtr: builder.mutation({
            query: (payload) => ({
                url: '/api/itp/session-qtr/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'delete'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['AddtQtrList'] : [])
        })
    })
});

export const {
    useGetITPListQuery,
    useGetITPV2ListQuery,

    useGetITPDetailsQuery,

    useGetQTRDetailsQuery,
    useAddUpdateITPMutation,
    useAddUpdateITPV2Mutation,
    useAddParentSignMutation,

    useAddUpdateQTRMutation,

    useDeleteITPMutation,
    useDeleteITPEIDTMutation,

    useItpSignMutation,
    useQtrSignMutation,

    useItpEidtSignMutation,

    useRequestSignMutation,

    useCloseITPMutation,

    useCloseITPEIDTMutation,

    useCloseQTRMutation,

    useGetITPV2DetailsQuery,

    useUnlockITPMutation,
    useUnlockITPEIDTMutation,

    useLazyGetItpHistoryQuery,

    useLazyGetItpEidtHistoryQuery,

    useGetTherapyHistoryQuery,
    useLazyGetTherapyHistoryQuery,
    useUpdateTherapyHistoryMutation,
    useAttendanceCheckinCheckoutMutation,
    useTherapyCheckinCheckoutMutation,
    useGetSwitchClassroomsQuery,

    useLockUnlockSessionMutation,
    useGetSessionGoalsQuery,
    useAddStudentGoalsResultMutation,
    useGetSessionHistoryQuery,
    useLazyGetSessionHistoryQuery,
    useGetPdcSessionServiceAvailedQuery,
    useGetSessionStudentsQuery,
    useChangeStudentAttendanceMutation,
    useStartSessionMutation,
    useGetEarlyDismissalReasonsQuery,

    // -- ADDT QTR REVIEW
    useGetAddtQtrDetailsQuery,
    useAddUpdateAddtQtrMutation,
    useAddtQtrSignMutation,
    useAddtQtrRequestSignMutation,
    useCloseAddtQtrMutation,
    useGetAddtQtrListQuery,
    useUnlockAddtQtrMutation,
    useLazyGetAddtQtrHistoryQuery,
    useDeleteAddtQtrMutation
} = itpApi;
